import React from 'react';
import { Text, Card } from '@perch-labs/shrike';
import { formatDate } from '@perch-labs/warbler';
import { copyFor } from 'config';
import { Row } from 'styles';
import {
  CardContent,
  ContractDownloadButton,
} from '../../check-lmi-eligibility.style';

interface LmiContractProps {
  createdAt?: string;
  displayName: string;
  fileUrl: string;
}

const getLmiContractCopy = copyFor('settings.contractAgreements');

export const LmiContract = ({
  createdAt,
  displayName,
  fileUrl,
}: LmiContractProps) => {
  return (
    <Card>
      <CardContent>
        <Row>
          <div>
            <Text tag="h2" textStyle="heading500">
              {displayName}
            </Text>
            {createdAt && (
              <Text margin={{ top: '8px' }}>
                {getLmiContractCopy('signedOn', {
                  acceptedDate: formatDate(createdAt),
                })}
              </Text>
            )}
          </div>
          <ContractDownloadButton
            aria-label={getLmiContractCopy('download', {
              agreementName: displayName,
            })}
            icon="UIDownload"
            onClick={() => window.open(fileUrl, '_newtab')}
          />
        </Row>
      </CardContent>
    </Card>
  );
};
